import(/* webpackMode: "eager", webpackExports: ["UtbrenthetTest"] */ "/vercel/path0/app/ressurser/utbrenthet-test/UtbrenthetTest.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareBar"] */ "/vercel/path0/components/shared/ShareBar.tsx");
